(function () {
  const PackPricing = window.VanabrewPackPricing;
  if (!PackPricing) return;

  const page = document.querySelector('[data-product-page]');
  if (!page) return;

  const configNode = document.querySelector('[data-product-config]');
  if (!configNode) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch {
    return;
  }

  const form = page.querySelector('.cdp-commerce');
  const variantInput = form?.querySelector('[name="id"]');
  const quantityInput = form?.querySelector('[name="quantity"]');
  const grindInput = page.querySelector('[data-product-grind]');
  const packLabel = page.querySelector('[data-product-pack-label]');
  const totalNode = page.querySelector('[data-product-total]');
  const decreaseBtn = page.querySelector('[data-product-quantity-decrease]');
  const increaseBtn = page.querySelector('[data-product-quantity-increase]');
  const grindGroup = page.querySelector('[data-product-grind-group]');
  const grindHint = page.querySelector('[data-product-grind-hint]');
  const addButton = form?.querySelector('[type="submit"]');

  const variants = Array.isArray(config.variants) ? config.variants : [];
  const soldOut = Boolean(config.soldOut);
  const packSizes = variants
    .map((variant) => Number(variant.packs))
    .filter((packs) => Number.isFinite(packs) && packs > 0)
    .sort((a, b) => a - b);
  const minPacks = packSizes[0] || 1;
  const bundleUnit = PackPricing.unitSizeFromVariants(variants);
  const maxSelectable = Number(config.maxSelectablePacks) || 20;

  let packCount = Number(config.initialPacks) || minPacks;
  if (!Number.isFinite(packCount) || packCount < minPacks) packCount = minPacks;
  if (packCount > maxSelectable) packCount = maxSelectable;

  const labels = config.labels || {};
  const labelSoldOut = labels.soldOut || 'Sold out';
  const labelAddToCart = labels.addToCart || 'Add to cart';
  const labelPackSingular = labels.packSingular || '1 pack';
  const labelPackPlural = labels.packPlural || '{{ count }} packs';

  function packLabelText(count) {
    if (soldOut) return labelSoldOut;
    if (count === 1) return labelPackSingular;
    return labelPackPlural.replace('{{ count }}', String(count));
  }

  function baseVariantForCount(count) {
    if (count <= bundleUnit) {
      return PackPricing.findVariant(variants, count);
    }
    return PackPricing.findVariant(variants, bundleUnit);
  }

  function canPurchaseCount(count) {
    if (soldOut || !variants.length) return false;
    const chunks = PackPricing.packChunks(count, bundleUnit);
    return chunks.every((size) => {
      const variant = PackPricing.findVariant(variants, size);
      return variant && variant.available;
    });
  }

  function hasGrindSelected() {
    return Boolean(grindInput?.value?.trim());
  }

  function setGrindHintVisible(visible) {
    if (!grindHint) return;
    grindHint.classList.toggle('is-visible', visible);
    grindHint.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function updateQuantityUI() {
    const canPurchase = canPurchaseCount(packCount);
    const grindReady = hasGrindSelected();
    const baseVariant = baseVariantForCount(Math.min(packCount, bundleUnit));

    if (form) form.dataset.packCount = String(packCount);
    if (quantityInput) quantityInput.value = '1';
    if (variantInput && baseVariant) variantInput.value = String(baseVariant.id);
    if (packLabel) packLabel.textContent = packLabelText(packCount);

    if (totalNode) {
      const totalCents = PackPricing.bundledPriceCents(packCount, variants);
      totalNode.textContent = PackPricing.formatMoney(totalCents, config.moneyFormat);
    }

    if (addButton) {
      const label = addButton.querySelector('.button__label');
      if (label) label.textContent = canPurchase ? labelAddToCart : labelSoldOut;

      if (!canPurchase) {
        // Truly unavailable — hard-disable.
        addButton.disabled = true;
        addButton.removeAttribute('aria-disabled');
      } else if (!grindReady) {
        // Visually disabled but clickable so we can prompt for grind.
        addButton.disabled = false;
        addButton.setAttribute('aria-disabled', 'true');
      } else {
        addButton.disabled = false;
        addButton.removeAttribute('aria-disabled');
      }
    }

    if (grindReady) setGrindHintVisible(false);

    if (decreaseBtn) decreaseBtn.disabled = soldOut || packCount <= minPacks;
    if (increaseBtn) increaseBtn.disabled = soldOut || packCount >= maxSelectable || !canPurchaseCount(packCount + 1);
  }

  function clearGrindSelection() {
    if (!grindGroup || !grindInput) return;

    grindGroup.querySelectorAll('.pill').forEach((pill) => {
      pill.classList.remove('pill--selected');
      pill.setAttribute('aria-checked', 'false');
    });

    grindInput.value = '';
    updateQuantityUI();
  }

  function selectGrind(button) {
    if (!grindGroup || !grindInput || !button) return;

    // Clicking the active grind clears it and disables Add to cart again.
    if (button.classList.contains('pill--selected') || button.getAttribute('aria-checked') === 'true') {
      clearGrindSelection();
      return;
    }

    grindGroup.querySelectorAll('.pill').forEach((pill) => {
      const selected = pill === button;
      pill.classList.toggle('pill--selected', selected);
      pill.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    grindInput.value = button.getAttribute('data-grind') || '';
    updateQuantityUI();
  }

  decreaseBtn?.addEventListener('click', () => {
    packCount = Math.max(minPacks, packCount - 1);
    updateQuantityUI();
  });

  increaseBtn?.addEventListener('click', () => {
    packCount = Math.min(maxSelectable, packCount + 1);
    updateQuantityUI();
  });

  grindGroup?.addEventListener('click', (event) => {
    const button = event.target.closest('.pill');
    if (!button || button.disabled) return;
    selectGrind(button);
  });

  // aria-disabled buttons still receive clicks — use that to guide grind selection.
  addButton?.addEventListener('click', (event) => {
    if (hasGrindSelected() || !canPurchaseCount(packCount)) return;
    event.preventDefault();
    setGrindHintVisible(true);
  });

  updateQuantityUI();
})();
